// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectProduct_custom-select__n8kmq","header-select":"SelectProduct_header-select__UvU64"};